import { IconButton, SxProps } from "@mui/material";
import { ReactElement } from "react";

import ChevronDown from "./icons/ChevronDown";
import ChevronUp from "./icons/ChevronUp";

export default function ExpandButton({
  open,
  onClick,
  sx = {},
  svgSx = {},
}: {
  open: boolean;
  onClick: () => any;
  sx?: SxProps;
  svgSx?: SxProps;
}): ReactElement {
  return (
    <IconButton onClick={onClick} sx={{ p: 0, ...sx }}>
      {open ? <ChevronUp sx={svgSx} /> : <ChevronDown sx={svgSx} />}
    </IconButton>
  );
}
